import { useRef } from 'react'
import type { GenerationConfig } from '@/types/autoGeneration'

// Configuración por defecto con intervalos de tiempo
const DEFAULT_TIME_CONFIG = {
  intervals: [
    {
      startMinute: 0,
      endMinute: 1,
      maxCallsPerInterval: 10, // Aumentado de 5 a 10 para permitir más llamadas por tipo
      callIntervalSeconds: 8, // Reducido de 10 a 8 segundos
      enabled: true,
      description: "Primer minuto - Títulos y reportes",
      // Sin restricciones - ambos permitidos
    },
    {
      startMinute: 1,
      endMinute: 3,
      maxCallsPerInterval: 15, // Aumentado de 8 a 15
      callIntervalSeconds: 12, // Reducido de 15 a 12 segundos
      enabled: true,
      description: "Minutos 1-3 - Solo reportes",
      reportOnly: true,
    },
    {
      startMinute: 3,
      endMinute: 8,
      maxCallsPerInterval: 12, // Aumentado de 6 a 12
      callIntervalSeconds: 30, // Reducido de 45 a 30 segundos
      enabled: true,
      description: "Minutos 3-8 - Solo reportes",
      reportOnly: true,
    },
    {
      startMinute: 8,
      endMinute: 15,
      maxCallsPerInterval: 8, // Aumentado de 4 a 8
      callIntervalSeconds: 45, // Reducido de 60 a 45 segundos
      enabled: true,
      description: "Minutos 8-15 - Solo reportes",
      reportOnly: true,
    },
    {
      startMinute: 15,
      endMinute: 999,
      maxCallsPerInterval: 6, // Aumentado de 2 a 6
      callIntervalSeconds: 90, // Reducido de 120 a 90 segundos
      enabled: true,
      description: "Después de 15 min - Solo reportes",
      reportOnly: true,
    },
  ],
  defaultInterval: {
    maxCallsPerInterval: 5, // Aumentado de 1 a 5
    callIntervalSeconds: 180, // Reducido de 300 a 180 segundos
  },
}

const DEFAULT_CONFIG: GenerationConfig = {
  timeBasedConfig: DEFAULT_TIME_CONFIG,
  titleGeneration: {
    enabled: true,
    maxRetries: 2,
    priority: 1,
  },
  reportGeneration: {
    enabled: true,
    maxRetries: 3,
    priority: 2,
  },
  global: {
    pauseOnEdit: true,
    editingGracePeriodSeconds: 10,
  },
}

export const useAutoGenerationConfig = (userConfig: Partial<GenerationConfig> = {}) => {
  const configRef = useRef<GenerationConfig | null>(null)
  
  // Initialize config only once
  if (!configRef.current) {
    configRef.current = {
      ...DEFAULT_CONFIG,
      timeBasedConfig: {
        ...DEFAULT_CONFIG.timeBasedConfig,
        intervals: userConfig.timeBasedConfig?.intervals || DEFAULT_CONFIG.timeBasedConfig.intervals,
        defaultInterval: userConfig.timeBasedConfig?.defaultInterval || DEFAULT_CONFIG.timeBasedConfig.defaultInterval,
      },
      titleGeneration: { ...DEFAULT_CONFIG.titleGeneration, ...userConfig.titleGeneration },
      reportGeneration: { ...DEFAULT_CONFIG.reportGeneration, ...userConfig.reportGeneration },
      global: { ...DEFAULT_CONFIG.global, ...userConfig.global },
    }
    console.log('🔧 AUTO_GEN_CONFIG: Config initialized once', configRef.current)
  }

  return configRef.current
}
